import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import getDate from '../../../Helpers/Date/GetDate';
import getStatusColor from '../../../Helpers/GetStatusColor';
import NoDashboardDataFound from '../../../Components/NotFound/NoDashboardDataFound';
import './DashboardOrderDetails.css';
import { getObjFromLS, setObjInLS } from '../../../Helpers';
import { useTranslation } from 'react-i18next';

export default function OrderDetailsTable({ data, tab }) {
  let history = useHistory();
  const { t } = useTranslation();

  const POClickHandler = (url) => {
    const dataFromLS = getObjFromLS('module');
    setObjInLS('module', {
      ...dataFromLS,
      moduleName: 'purchaseorders',
      urlPath: url,
    });
    history.push(url);
  };
  //console.log(data);

  switch (tab) {
    case 'salesorder':
      return (
        <div className="orders-body">
          {data.length ? (
            <div className="orders-table">
              <table className="lopi orders-table-body dashboard-table-main">
                <thead>
                  <tr className="orders-table-head">
                    <th>
                      <span>
                        {t('Dashboard.sales_Vs_Purchase.salesorder.order_date')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t(
                          'Dashboard.sales_Vs_Purchase.salesorder.sales_order_no'
                        )}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.salesorder.customer')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.salesorder.status')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.salesorder.amount')}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((sales, index) => (
                    <tr className="orders-table-list yes" key={index}>
                      <td>{getDate(sales.order_date)}</td>
                      <td className="check">
                        <Link to={`salesorders/${sales.id}`}>
                          {sales.sales_order_no}
                        </Link>
                      </td>
                      <td className="check">
                        <Link to={`contacts/${sales.customer_id}`}>
                          {sales.so_display_name
                            ? sales.so_display_name
                            : sales.display_name}
                        </Link>
                      </td>
                      <td>
                        <span className={getStatusColor(sales.status)}>
                          {sales.status === 'confirmed'
                            ? t('saleOrder.filter_options.confirmed')
                            : sales.status === 'closed'
                            ? t('saleOrder.filter_options.closed')
                            : sales.status === 'draft'
                            ? t('Items.draft')
                            : sales.status}
                        </span>
                      </td>
                      <td>
                        {sales.currency.symbol}
                        {parseFloat(sales.total).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-data">
              {t('Dashboard.sales_Vs_Purchase.salesorder.empty')}
            </div>
          )}
        </div>
      );
    case 'invoice':
      return (
        <div className="orders-body">
          {data.length ? (
            <div className="orders-table">
              <table className="lopi orders-table-body orders-bills-table-body dashboard-invoice-tb">
                <thead>
                  <tr className="orders-table-head">
                    <th>
                      {t('Dashboard.sales_Vs_Purchase.invoice.invoice_date')}
                      <span></span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.invoice.invoice_no')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.invoice.customer')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {t('Dashboard.sales_Vs_Purchase.invoice.status')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.invoice.amount')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.invoice.balance_due')}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((invoice, index) => (
                    <tr className="orders-table-list yes" key={index}>
                      <td>{getDate(invoice.invoice_date)}</td>
                      <td className="check">
                        <Link to={`invoices/${invoice.id}`}>
                          {invoice.invoice_no}
                        </Link>
                      </td>
                      <td className="check">
                        <Link to={`contacts/${invoice.customer_id}`}>
                          {invoice.display_name
                            ? invoice.display_name
                            : invoice.customer?.display_name}
                        </Link>
                      </td>
                      <td>
                        <span className={getStatusColor(invoice.status)}>
                          {invoice.status === 'paid'
                            ? t('Invoice.filters.paid')
                            : invoice.status === 'overdue'
                            ? t('Invoice.filters.overdue')
                            : invoice.status === 'draft'
                            ? t('Items.draft')
                            : invoice.status}
                        </span>
                      </td>
                      <td>
                        {invoice.currency.symbol}
                        {parseFloat(invoice.exchanged_total).toFixed(2)}
                      </td>
                      <td>
                        {invoice.currency.symbol}
                        {parseFloat(invoice.exchanged_payment_due).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-data">
              {t('Dashboard.sales_Vs_Purchase.invoice.empty')}
            </div>
          )}
        </div>
      );

    case 'purchaseorder':
      return (
        <div className="orders-body">
          {data.length ? (
            <div className="orders-table">
              <table className="lopi orders-table-body dashboard-purchase-tb UIUX_dashboard_purchase-table">
                <thead>
                  <tr className="orders-table-head">
                    <th>
                      <span>
                        {' '}
                        {t(
                          'Dashboard.sales_Vs_Purchase.purchaseorder.order_date'
                        )}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t(
                          'Dashboard.sales_Vs_Purchase.purchaseorder.purchase_order_no'
                        )}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.purchaseorder.vendor')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.purchaseorder.status')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.purchaseorder.amount')}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((purchase, index) => (
                    <tr className="orders-table-list yes" key={index}>
                      <td>{getDate(purchase.order_date)}</td>
                      <td className="check">
                        {/*<Link to={`purchaseorders/${purchase.id}`}>
                          {purchase.purchase_order_no}
                        </Link>*/}
                        <a
                          //  to={`purchaseorders/${purchase.id}`}
                          onClick={() => {
                            POClickHandler(`purchaseorders/${purchase.id}`);
                          }}
                        >
                          {purchase.purchase_order_no}
                        </a>
                      </td>
                      <td className="check">
                        <Link to={`contacts/${purchase.vendor_id}`}>
                          {purchase.vendor.display_name}
                        </Link>
                      </td>
                      <td>
                        <span className={getStatusColor(purchase.status)}>
                          {t(`status.${purchase.status}`)}
                        </span>
                      </td>
                      <td>
                        {purchase.currency.symbol}
                        {parseFloat(purchase.total).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-data">
              {' '}
              {t('Dashboard.sales_Vs_Purchase.purchaseorder.empty')}
            </div>
          )}
        </div>
      );

    case 'bills':
      return (
        <div className="orders-body">
          {data.length ? (
            <div className="orders-table">
              <table className="lopi orders-table-body orders-bills-table-body">
                <thead>
                  <tr className="orders-table-head">
                    <th>
                      {t(
                        'Dashboard.sales_Vs_Purchase.bills_table.bill_due_date'
                      )}
                      <span></span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.bills_table.bill_no')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.bills_table.vendor')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.bills_table.status')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t('Dashboard.sales_Vs_Purchase.bills_table.amount')}
                      </span>
                    </th>
                    <th>
                      <span>
                        {' '}
                        {t(
                          'Dashboard.sales_Vs_Purchase.bills_table.balance_due'
                        )}
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((bill, index) => (
                    <tr className="orders-table-list yes" key={index}>
                      <td>{getDate(bill.due_date)}</td>
                      <td className="check">
                        <Link to={`bills/${bill.id}`}>{bill.bill_no}</Link>
                      </td>
                      <td className="check">
                        <Link to={`contacts/${bill.vendor_id}`}>
                          {bill.vendor.display_name}
                        </Link>
                      </td>
                      <td>
                        <span className={getStatusColor(bill.status)}>
                          {t(`status.${bill.status}`)}
                        </span>
                      </td>
                      <td>
                        {bill.currency.symbol}
                        {parseFloat(bill.total).toFixed(2)}
                      </td>
                      <td>
                        {bill.currency.symbol}
                        {parseFloat(bill.balance_due).toFixed(2)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="empty-data">
              {' '}
              {t('Dashboard.sales_Vs_Purchase.bills_table.empty')}
            </div>
          )}
        </div>
      );
    default:
      return (
        <NoDashboardDataFound
          message={t('Dashboard.sales_Vs_Purchbalance_duease.empty')}
        />
      );
  }
}
